module.exports = __webpack_public_path__ + "media/components/country-flag/static/gh-0c82cc748d674c101d1fe8e7e07e077e.svg";